import SvgIcon from '@material-ui/core/SvgIcon';

type QEErrorIconProps = {
  isDark?: boolean;
  fontSize?: 'inherit' | 'medium' | 'default' | 'large' | 'small' | undefined;
};

export function NoQeMetricsErrorIcon({ isDark, fontSize }: QEErrorIconProps) {
  return (
    <SvgIcon
      viewBox="0 0 244 231"
      fontSize={fontSize}
      style={{ width: 244, height: 231 }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M235.623 124.225C241.27 121.49 244 117.622 244 113.661C244 109.793 241.27 106.209 235.623 104.228L189.778 88.3815L209.454 48.1052C210.489 46.0301 210.865 43.955 210.865 42.0685C210.865 36.5977 206.724 32.5418 201.357 32.5418C199.381 32.5418 197.404 32.919 195.332 33.9567L153.724 54.3304L132.073 7.82885C129.72 2.6409 125.86 0 122 0C118.235 0 114.375 2.6409 112.022 7.82885L90.3706 54.3304L48.7625 33.9567C46.5975 32.919 44.6206 32.5418 42.7379 32.5418C37.3721 32.5418 33.1356 36.5977 33.1356 42.0685C33.1356 43.955 33.6066 46.0301 34.6419 48.1052L54.3166 88.3815L8.37791 104.228C2.91841 106.115 0 109.888 0 113.755C0 117.622 2.8243 121.49 8.37791 124.225L52.3397 145.354L28.6173 195.723C27.4879 197.987 27.0169 200.156 27.0169 202.137C27.0169 207.042 30.3118 210.532 34.9247 210.532C36.9015 210.532 39.0666 209.871 41.3258 208.551L97.5251 175.255L112.963 222.983C114.752 228.265 118.329 231 122 231C125.86 231 129.343 228.265 131.038 222.983L146.57 175.255L202.77 208.551C205.029 209.871 207.194 210.437 209.076 210.437C213.595 210.437 217.079 207.136 217.079 202.231C217.079 200.25 216.514 197.987 215.479 195.723L191.661 145.354L235.623 124.225ZM223.855 114.509V113.849L173.868 98.3802C171.893 97.8139 170.857 96.588 170.857 95.0787C170.857 94.3243 171.139 93.5694 171.516 92.815L194.015 49.8031L193.545 49.3315L150.335 72.158C149.488 72.6295 148.735 72.8181 147.982 72.8181C146.57 72.8181 145.44 71.9694 144.781 70.2715L122.377 19.8079H121.718L99.3137 70.2715C98.5608 71.9694 97.4309 72.8181 96.0188 72.8181C95.36 72.8181 94.6066 72.6295 93.7596 72.158L50.5511 49.3315L50.0806 49.8031L72.485 92.815C72.9556 93.5694 73.1438 94.3243 73.1438 95.0787C73.1438 96.588 72.1081 97.8139 70.2254 98.3802L20.2394 113.849V114.509L68.4372 135.638C70.1313 136.393 71.0728 137.619 71.0728 139.128C71.0728 139.694 70.8846 140.449 70.5082 141.109L45.6559 191.195L46.2206 191.761L101.573 156.673C102.42 156.201 103.267 155.823 104.02 155.823C105.527 155.823 106.75 156.956 107.315 158.842L121.718 207.702H122.377L136.78 158.842C137.345 156.956 138.474 155.823 139.981 155.823C140.734 155.823 141.581 156.201 142.522 156.673L197.875 191.761L198.44 191.195L173.587 141.109C173.21 140.449 173.022 139.694 173.022 139.128C173.022 137.619 173.868 136.393 175.658 135.638L223.855 114.509Z"
        fill={isDark ? '#4C4C4C' : '#DEE0E1'}
      />
      <path
        d="M71 85H165.091C171.976 85.2981 185.592 88.9348 184.98 101.097C184.368 113.259 172.996 116.896 167.386 117.194H142.136M167.386 153.86C141.632 153.86 89.4972 154.176 87.0643 153.86C80.1796 152.965 71.765 147.6 71.765 135.08C71.765 125.064 77.8847 118.088 91.6541 117.194H129.368"
        stroke="#B8C1C4"
        stroke-width="3"
        fill="none"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M134.625 175.667C145.095 175.667 153.583 167.179 153.583 156.708C153.583 146.238 145.095 137.75 134.625 137.75C124.155 137.75 115.667 146.238 115.667 156.708C115.667 167.179 124.155 175.667 134.625 175.667ZM134.625 178.583C146.706 178.583 156.5 168.79 156.5 156.708C156.5 144.627 146.706 134.833 134.625 134.833C122.544 134.833 112.75 144.627 112.75 156.708C112.75 168.79 122.544 178.583 134.625 178.583Z"
        fill="#666B6D"
      />
      <path
        d="M134.625 175.667C145.095 175.667 153.583 167.179 153.583 156.708C153.583 146.238 145.095 137.75 134.625 137.75C124.155 137.75 115.667 146.238 115.667 156.708C115.667 167.179 124.155 175.667 134.625 175.667Z"
        fill="white"
      />
      <path
        d="M151.061 174.955L149.59 175.119L149.218 176.464L160.782 190.245L162.606 188.714L151.061 174.955Z"
        fill="#666B6D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M145.998 177.164L158.547 192.12C159.583 193.354 161.422 193.515 162.657 192.479L164.481 190.949C165.715 189.913 165.876 188.073 164.84 186.84L152.291 171.884L147.305 172.438L145.998 177.164ZM149.59 175.119L151.061 174.955L162.606 188.714L160.782 190.245L149.218 176.464L149.59 175.119Z"
        fill="#666B6D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M134.5 172C143.061 172 150 165.061 150 156.5C150 147.939 143.061 141 134.5 141C125.939 141 119 147.939 119 156.5C119 165.061 125.939 172 134.5 172ZM132.175 164.236C132.175 162.892 133.196 161.925 134.486 161.925C135.804 161.925 136.825 162.892 136.825 164.236C136.825 165.58 135.804 166.575 134.486 166.575C133.196 166.575 132.175 165.58 132.175 164.236ZM133.217 147.2C133.112 147.2 133.009 147.221 132.912 147.263C132.816 147.304 132.729 147.364 132.657 147.439C132.585 147.515 132.529 147.605 132.492 147.702C132.455 147.8 132.439 147.905 132.443 148.009L132.917 158.859C132.926 159.059 133.012 159.247 133.156 159.385C133.301 159.523 133.493 159.6 133.692 159.6H135.309C135.509 159.6 135.701 159.523 135.845 159.385C135.99 159.247 136.075 159.059 136.084 158.859L136.557 148.009C136.561 147.904 136.545 147.8 136.508 147.702C136.471 147.604 136.415 147.515 136.342 147.439C136.27 147.363 136.183 147.303 136.087 147.262C135.99 147.221 135.887 147.2 135.782 147.2H133.217Z"
        fill="#BE3232"
      />
      <rect x="54" y="77" width="19" height="17" fill="#DA6944" />
      <circle cx="174.5" cy="153.5" r="8.5" fill="#DA6944" />
      <circle cx="98" cy="85" r="4" fill={isDark ? '#B8C1C4' : '#4C4C4C'} />
      <circle cx="131" cy="85" r="4" fill={isDark ? '#B8C1C4' : '#4C4C4C'} />
      <circle cx="165" cy="85" r="4" fill={isDark ? '#B8C1C4' : '#4C4C4C'} />
      <circle cx="181" cy="112" r="4" fill={isDark ? '#B8C1C4' : '#4C4C4C'} />
      <circle cx="153" cy="117" r="4" fill={isDark ? '#B8C1C4' : '#4C4C4C'} />
      <path
        d="M138.913 112.165L139.495 108.004L137.007 108L137.575 112.163L138.913 112.165Z"
        fill="#FF3F3F"
      />
      <path
        d="M136.391 123.226L136.471 127.427L134 127.133L135.064 123.068L136.391 123.226Z"
        fill="#FF3F3F"
      />
      <path
        d="M141.68 113.57L144.174 110.189L141.989 109L140.506 112.931L141.68 113.57Z"
        fill="#FF3F3F"
      />
      <path
        d="M139.109 122.311L141.843 125.501L139.749 126.846L137.984 123.034L139.109 122.311Z"
        fill="#FF3F3F"
      />
      <path
        d="M134.827 112.514L132 109.407L134.052 108L135.93 111.758L134.827 112.514Z"
        fill="#FF3F3F"
      />
      <path
        d="M132.827 121.325L130 124.433L132.052 125.839L133.93 122.081L132.827 121.325Z"
        fill="#FF3F3F"
      />
    </SvgIcon>
  );
}

export function QeScoreLoadErrorIcon({ isDark, fontSize }: QEErrorIconProps) {
  return (
    <SvgIcon
      style={{ width: 244, height: 231 }}
      viewBox="0 0 244 231"
      fill="none"
      fontSize={fontSize}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M141.177 86.0303L155.088 57.5346C155.82 56.0665 156.086 54.5984 156.086 53.2637C156.086 49.393 153.158 46.5235 149.364 46.5235C147.966 46.5235 146.569 46.7903 145.104 47.5246L115.686 61.9391L100.378 29.0389C98.7145 25.3685 95.9857 23.5 93.257 23.5C90.5947 23.5 87.8659 25.3685 86.2021 29.0389L70.894 61.9391L41.4762 47.5246C39.9454 46.7903 38.5477 46.5235 37.2166 46.5235C33.4229 46.5235 30.4276 49.393 30.4276 53.2637C30.4276 54.5984 30.7606 56.0665 31.4926 57.5346L45.403 86.0303L12.9234 97.242C9.06338 98.5767 7 101.246 7 103.982C7 106.718 8.99684 109.454 12.9234 111.39L44.0053 126.338L27.233 161.975C26.4345 163.577 26.1015 165.111 26.1015 166.513C26.1015 169.983 28.4311 172.452 31.6925 172.452C33.0902 172.452 34.6209 171.985 36.2182 171.051L75.9523 147.493L76.4722 149.102V135.832L39.6789 159.172L39.2797 158.772L56.8508 123.335C57.117 122.868 57.25 122.334 57.25 121.934C57.25 120.866 56.5843 119.999 55.3866 119.465L21.3097 104.516V104.049L56.6509 93.1045C57.982 92.7038 58.7142 91.8365 58.7142 90.7687C58.7142 90.2349 58.5812 89.7008 58.2485 89.1671L42.408 58.7359L42.7407 58.4023L73.2901 74.5521C73.8889 74.8857 74.4216 75.0192 74.8874 75.0192C75.8858 75.0192 76.6846 74.4187 77.2169 73.2174L93.0573 37.5142H93.5231L109.364 73.2174C109.829 74.4187 110.628 75.0192 111.627 75.0192C112.159 75.0192 112.691 74.8857 113.29 74.5521L143.84 58.4023L144.173 58.7359L128.265 89.1671C128.149 89.401 128.045 89.6349 127.965 89.8688H152.274L141.177 86.0303Z"
        fill={isDark ? '#757C7D' : '#D9D9D9'}
      />
      <path
        d="M235.886 95.2778V186.5C235.886 190.642 232.528 193.999 228.386 194H84.6106C80.4685 194 77.1106 190.642 77.1106 186.5V95.2778H235.886ZM84.6106 81.5044H228.386C232.528 81.5044 235.886 84.8623 235.886 89.0044V94.2778H77.1106V89.0044C77.1106 84.8623 80.4685 81.5044 84.6106 81.5044Z"
        fill={isDark ? '#757C7D' : '#D9D9D9'}
        stroke="#333333"
      />
      <circle cx="93.69" cy="88.1667" r="2.75475" fill="#333333" />
      <circle cx="85.9769" cy="88.1667" r="2.75475" fill="#333333" />
      <circle cx="101.403" cy="88.1667" r="2.75475" fill="#333333" />
      <path
        d="M154.351 143.084V132.331H158.648L158.65 143.084H154.351Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M158.399 118.422C157.655 117.016 155.343 117.016 154.6 118.422L135.262 154.98C135.088 155.308 135.002 155.675 135.012 156.046C135.022 156.417 135.128 156.779 135.319 157.097C135.51 157.415 135.78 157.678 136.103 157.86C136.426 158.043 136.791 158.138 137.162 158.137H175.837C176.207 158.138 176.571 158.043 176.894 157.861C177.217 157.679 177.487 157.416 177.678 157.098C177.869 156.78 177.975 156.418 177.985 156.048C177.994 155.677 177.908 155.31 177.734 154.983L158.399 118.422ZM154.351 151.686H158.648V147.385H154.351V151.686ZM154.351 132.331V143.084H158.65L158.648 132.331H154.351Z"
        fill="#BB3118"
      />
      <path
        d="M158.648 151.686H154.351V147.385H158.648V151.686Z"
        fill="white"
      />
    </SvgIcon>
  );
}
